import React, { useCallback, useEffect, useState } from 'react'
import './AdvertiserDashboardNewCampaign.css';
import './CreativeEditorModal.css';
import { Link, useSearchParams } from 'react-router-dom';
import { usePlatformAdvertisingAgreement } from '../../../../hooks/usePlatformAdvertisingAgreement';
import { platformAgreementPath } from '../../../../utils/platformAgreementUrl';
import { useSelector } from 'react-redux'
import { getToken } from '../../../../features/token/tokenSaver';
import { getScreenLocations } from '../../../../services/getScreenLocations';
import ScreenMapView from '../ScreenMapView/ScreenMapView';
import ScreenSelector from '../ScreenSelector/ScreenSelector';
import { useAdvertiserOnboarding } from '../../AdvertiserOnboarding/AdvertiserOnboardingContext';
import '../../AdvertiserOnboarding/AdvertiserOnboarding.css';
import { ALL_SCREENS_BUNDLE_USD, PLAYS_PER_SCREEN_MONTH } from '../../../../utils/advertiserScreenPricing';
import { RingLoader } from 'react-spinners';
import PaymentButton from './PaymentButton/PaymentButton';
import CreativeCropModal from './CreativeCropModal';
import CreativePreviewModal from './CreativePreviewModal';
import CreativeFileUpload from './CreativeFileUpload';
import CreativeProcessingOverlay from './CreativeProcessingOverlay';
import {
    blobToPreviewUrl,
    blobToRawBase64,
    ensureBlobUnderMaxBytes,
    fileToRawBase64,
    getCroppedImageBlob,
    isAllowedCreativeFile,
    isImageFile,
    isTargetAspectRatio,
    isVideoFile,
    loadVideoDimensions,
    MAX_CREATIVE_BYTES,
    MAX_CREATIVE_VIDEO_BYTES,
    MAX_CREATIVE_VIDEO_TRANSCODE_THRESHOLD_BYTES,
    creativeVideoHint,
    OUTPUT_SIZE,
    prepareImageFileForUpload,
    resizeImageToOutputBlob,
} from '../../../../utils/creativeAspectRatio';

const CREATIVE_INPUT_IDS = {
    horizontal: 'fileUploadNewCampaignHorizontal',
    vertical: 'fileUploadNewCampaignVertical',
};

export default function AdvertiserDashboardNewCampaign(props) {
    const [searchParams] = useSearchParams();
    const token = useSelector(getToken);
    const onboarding = useAdvertiserOnboarding();
    const [campaignName, setCampaignName] = useState("");
    const [campaignHorizontalContent, setCampaignHorizontalContent] = useState("");
    const [campaignVerticalContent, setCampaignVerticalContent] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [submitError, setSubmitError] = useState("");
        const [showPayment, setShowPayment] = useState(false);
        const [pendingFormData, setPendingFormData] = useState(null);
        const [pendingRedirect, setPendingRedirect] = useState(false);
    const [tosAccepted, setTosAccepted] = useState(false);
    const [tosError, setTosError] = useState('');
    const [selectedScreenIds, setSelectedScreenIds] = useState([]);
    const [fleetSize, setFleetSize] = useState(1);
    const [monthlyFee, setMonthlyFee] = useState(0);
    const [screenSelectionError, setScreenSelectionError] = useState('');
    const agreementOptions = {
        screenCount: selectedScreenIds.length,
        selectedScreenIds,
        fleetSize,
    };
    const { doc: agreementDoc } = usePlatformAdvertisingAgreement(
        monthlyFee || ALL_SCREENS_BUNDLE_USD,
        agreementOptions
    );
    const tosVersion = agreementDoc?.version;
    const agreementLink = platformAgreementPath(monthlyFee, agreementOptions);
    
    // Legacy state - to be removed once API is updated
    const [campaignViewingTime, setCampaignViewingTime] = useState({currentTimezone: "", utcTime:""});
    const [campaignBudget, setCampaignBudget] = useState("$10.00");
    const [totalCampaignImpressions, setTotalCampaignImpressions] = useState("1");
    const [costPerImpression, setCostPerImpression] = useState("$10.00");
    const [allLocations, setAllLocations] = useState([]);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [selectedScreenType, setSelectedScreenType] = useState({ value: 1, label: "Storefront Window" });
    const [minCPI, setMinCPI] = useState(.03);
    const [minImpressions, setMinImpressions] = useState(1);
    const [valuesChecked, setValuesChecked] = useState(false);
    const [currentTimezone, setCurrentTimezone] = useState(null);
    const [creativeEditor, setCreativeEditor] = useState(null);
    const [cropExporting, setCropExporting] = useState(false);
    const [creativeFileNames, setCreativeFileNames] = useState({ horizontal: '', vertical: '' });
    const [creativeProcessing, setCreativeProcessing] = useState(null);
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    function parsed() {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            return null;
        }
    }
    function getAllLocations() {
        getScreenLocations(token).then(result => {
            let options = [];
            result.data.data.forEach(location => {
                options.push({label: location.City +","+ location.State, value: location.LocationId})
            });
            setAllLocations(options);
        }).catch(e => {
            setAllLocations([]);
        })
    }
    function campaignNameOnChange(alteredValue) {
        setCampaignName(alteredValue);
    }
    function campaignViewingTimeOnChange(alteredValue) {
        var matches = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(alteredValue);
        if (matches) {
            const newCampaignViewingTime = { currentTimezone: alteredValue, utcTime: convertToUTC(alteredValue) };
            setCampaignViewingTime(newCampaignViewingTime);
        }
    }
    function campaignImpressionsOnBlur(alteredValue) {
        var impressions = parseFloat(alteredValue);
        if (impressions < minImpressions) {
            impressions = minImpressions;
        }
         if (impressions) {
            setTotalCampaignImpressions(impressions.toString())
     
        }
        // calculateBudget(costPerImpression, impressions);
        calculateCPI(campaignBudget, impressions);

    }
    function calculateBudget(costPerImpression, totalCampaignImpressions) {
        
        if (totalCampaignImpressions && costPerImpression) {
            var impressions = parseFloat(totalCampaignImpressions.toString());
            var formatted = costPerImpression.toString().replace(/\$/g, "");
            var formatted = formatted.replace(/\,/g, "");
            if (formatted.length === 0) {
                formatted = "0"
            }
            var cpi = parseFloat(formatted);
            var budget = formatter.format(cpi * impressions);
            if (budget) {
                setCampaignBudget(budget);
            }
        }
    }
    function calculateCPI(totalBudget, totalCampaignImpressions) {

        if (totalCampaignImpressions && totalBudget) {
            var impressions = parseFloat(totalCampaignImpressions.toString());
            var formatted = totalBudget.toString().replace(/\$/g, "");
            formatted = formatted.replace(/\,/g, "");
            if (formatted.length === 0) {
                formatted = "0"
            }
            var totalBudget = parseFloat(formatted);
            var cpiRaw = totalBudget / impressions;
            var cpi = formatter.format(cpiRaw);
            if (cpiRaw < minCPI) {
                calculateBudget(costPerImpression, impressions);
            }
            else {
                setCostPerImpression(cpi);

            }
        }
    }

    function campaignImpressionsOnChange(alteredValue) {
        var impressions = parseFloat(alteredValue);
        setValuesChecked(false);

        if (impressions) {
            setTotalCampaignImpressions(impressions.toString())
        }
        else {
            setTotalCampaignImpressions("")

        }
        // calculateBudget(costPerImpression, impressions);
    }
    function campaignBudgetOnBlur(alteredValue) {
        var formatted = alteredValue.replace("$", "");
        formatted = formatted.replace(/\,/g, "")
        var budget = parseFloat(formatted);

        if (formatted.length == 0) {
            budget = 10;
        }
        if (budget !== NaN || budget !== null || budget !== undefined) {
            if (budget < 10) {
                budget = 10;
            }
            setCampaignBudget(formatter.format(budget.toString()))
        }
        calculateCPI(budget, totalCampaignImpressions);

    }
    function cpiOnChange(alteredValue) {
        setValuesChecked(false);
        var formatted = alteredValue.replace("$", "");
        formatted = formatted.replace(/\,/g, "")
        var budget = parseFloat(formatted);

        if (budget || budget == 0) {
            setCostPerImpression("$"+formatted.toString());
        }
        else {
            setCostPerImpression("$")

        }
        
        // calculateBudget(budget, totalCampaignImpressions);
    }
    function calculateImpressions(budget, CPI) {
        var rawNewImpressions = budget/CPI;
        if (rawNewImpressions && rawNewImpressions >= minImpressions) {
            setTotalCampaignImpressions(Math.trunc(rawNewImpressions).toString())
        }
        else {
            setTotalCampaignImpressions(minImpressions.toString())

        }
    }
    function cpiOnBlur(alteredValue) {
        var formatted = alteredValue.replace("$", "");
        formatted = formatted.replace(/\,/g, "");
        var formattedBudget = campaignBudget.replace("$", "");
        formattedBudget = formattedBudget.replace(/\,/g, "");
        formattedBudget = parseFloat(formattedBudget);
        var cpi = parseFloat(formatted);
        
        if (formatted.length == 0) {
            cpi = minCPI;
        }
        if (cpi !== NaN && cpi !== null && cpi !== undefined && (cpi * parseFloat(totalCampaignImpressions)) < formattedBudget) {
            if (cpi < minCPI) {
                cpi = minCPI;
            }
            setCostPerImpression(formatter.format(cpi.toString()));
        }
        else {
            calculateCPI(campaignBudget, totalCampaignImpressions);
        }
        calculateImpressions(formattedBudget,formatted)
        // calculateBudget(budget, totalCampaignImpressions);

    }
    function campaignBudgetOnChange(alteredValue) {
        setValuesChecked(false)
        var formatted = alteredValue.replace("$", "");
        formatted = formatted.replace(/\,/g, "");
        var budget = parseFloat(formatted);
        setCampaignBudget(alteredValue);
        // if (budget) {
        //     setCampaignBudget("$"+ formatted.toString());
        // }
        // else {
        //     setCampaignBudget("$")

        // }
        // calculateCPI(budget, totalCampaignImpressions);

    }
    const revokeCreativeEditorUrls = useCallback((editor) => {
        if (!editor) {
            return;
        }
        if (editor.previewUrl && editor.previewUrl.startsWith('blob:')) {
            URL.revokeObjectURL(editor.previewUrl);
        }
    }, []);

    const clearCreativeInput = useCallback((inputId) => {
        const input = document.querySelector(`#${inputId}`);
        if (input) {
            input.value = '';
        }
    }, []);

    const closeCreativeEditor = useCallback(() => {
        setCreativeEditor((prev) => {
            revokeCreativeEditorUrls(prev);
            return null;
        });
        setCropExporting(false);
    }, [revokeCreativeEditorUrls]);

    const clearSlotContent = useCallback((slot) => {
        if (slot === 'horizontal') {
            setCampaignHorizontalContent('');
        } else {
            setCampaignVerticalContent('');
        }
        setCreativeFileNames((prev) => ({ ...prev, [slot]: '' }));
    }, []);

    const commitCreativeBase64 = useCallback((slot, base64, fileName) => {
        if (slot === 'horizontal') {
            setCampaignHorizontalContent(base64);
        } else {
            setCampaignVerticalContent(base64);
        }
        setCreativeFileNames((prev) => ({ ...prev, [slot]: fileName }));
    }, []);

    const openImagePreviewEditor = useCallback(async (slot, file, dataUrl, inputId) => {
        const outputSize = OUTPUT_SIZE[slot];
        let blob = await resizeImageToOutputBlob(dataUrl, outputSize);
        blob = await ensureBlobUnderMaxBytes(blob);
        const previewUrl = blobToPreviewUrl(blob);
        setCreativeEditor({
            slot,
            step: 'preview',
            imageSrc: dataUrl,
            file,
            previewUrl,
            pendingBlob: blob,
            isVideo: false,
            inputId,
        });
    }, []);

    const processCreativeUpload = useCallback(async (e, slot) => {
        const inputId = CREATIVE_INPUT_IDS[slot];
        const file = e.target.files?.[0];
        if (!file) {
            return;
        }

        if (!isAllowedCreativeFile(file)) {
            alert('Please upload a file with the file type JPG, PNG, MP4, MOV, or WebM');
            clearCreativeInput(inputId);
            setCreativeFileNames((prev) => ({ ...prev, [slot]: '' }));
            return;
        }

        closeCreativeEditor();
        clearSlotContent(slot);
        setCreativeFileNames((prev) => ({ ...prev, [slot]: file.name }));

        const needsResize = isImageFile(file) && file.size > MAX_CREATIVE_BYTES;
        const processingMessage = isVideoFile(file)
            ? 'Processing your video…'
            : needsResize
                ? 'Resizing your image…'
                : 'Preparing your image…';

        setCreativeProcessing({ message: processingMessage });

        try {
            if (isVideoFile(file)) {
                if (file.size > MAX_CREATIVE_VIDEO_BYTES) {
                    alert('This video is too large. Maximum upload size is 80MB. Try a shorter clip or lower resolution.');
                    clearCreativeInput(inputId);
                    setCreativeFileNames((prev) => ({ ...prev, [slot]: '' }));
                    return;
                }
                if (file.size > MAX_CREATIVE_VIDEO_TRANSCODE_THRESHOLD_BYTES) {
                    alert('Large videos are automatically re-encoded to reduce size and fit signage playback.');
                }
                const { width, height } = await loadVideoDimensions(file);
                if (!isTargetAspectRatio(width, height, slot)) {
                    alert(slot === 'horizontal'
                        ? 'Video aspect ratio must be 16:9'
                        : 'Video aspect ratio must be 9:16');
                    clearCreativeInput(inputId);
                    setCreativeFileNames((prev) => ({ ...prev, [slot]: '' }));
                    return;
                }
                const base64 = await fileToRawBase64(file);
                commitCreativeBase64(slot, base64, file.name);
                return;
            }

            if (!isImageFile(file)) {
                alert('Please upload a file with the file type JPG, PNG, MP4, MOV, or WebM');
                clearCreativeInput(inputId);
                setCreativeFileNames((prev) => ({ ...prev, [slot]: '' }));
                return;
            }

            const { file: imageFile, dataUrl } = await prepareImageFileForUpload(file);
            const image = await new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => resolve(img);
                img.onerror = reject;
                img.src = dataUrl;
            });

            if (isTargetAspectRatio(image.width, image.height, slot)) {
                await openImagePreviewEditor(slot, imageFile, dataUrl, inputId);
                return;
            }

            setCreativeEditor({
                slot,
                step: 'crop',
                imageSrc: dataUrl,
                file: imageFile,
                inputId,
            });
        } catch (err) {
            console.error('Creative upload failed:', err);
            alert('Could not process this file. Please try another image or video.');
            clearCreativeInput(inputId);
            setCreativeFileNames((prev) => ({ ...prev, [slot]: '' }));
        } finally {
            setCreativeProcessing(null);
        }
    }, [
        clearCreativeInput,
        clearSlotContent,
        closeCreativeEditor,
        commitCreativeBase64,
        openImagePreviewEditor,
        prepareImageFileForUpload,
    ]);

    const handleCreativeEditorCancel = useCallback(() => {
        if (creativeEditor?.inputId) {
            clearCreativeInput(creativeEditor.inputId);
        }
        if (creativeEditor?.slot) {
            setCreativeFileNames((prev) => ({ ...prev, [creativeEditor.slot]: '' }));
        }
        closeCreativeEditor();
    }, [creativeEditor, clearCreativeInput, closeCreativeEditor]);

    const handleCropNext = useCallback(async ({ croppedAreaPixels, rotation }) => {
        if (!creativeEditor || creativeEditor.step !== 'crop') {
            return;
        }
        setCropExporting(true);
        try {
            let blob = await getCroppedImageBlob(
                creativeEditor.imageSrc,
                croppedAreaPixels,
                rotation,
                OUTPUT_SIZE[creativeEditor.slot]
            );
            blob = await ensureBlobUnderMaxBytes(blob);
            const previewUrl = blobToPreviewUrl(blob);
            setCreativeEditor((prev) => {
                revokeCreativeEditorUrls(prev);
                return {
                    slot: prev.slot,
                    step: 'preview',
                    imageSrc: prev.imageSrc,
                    file: prev.file,
                    previewUrl,
                    pendingBlob: blob,
                    isVideo: false,
                    inputId: prev.inputId,
                };
            });
        } catch (err) {
            console.error('Crop export failed:', err);
            alert('Could not crop this image. Please try again.');
        } finally {
            setCropExporting(false);
        }
    }, [creativeEditor, revokeCreativeEditorUrls]);

    const handlePreviewNext = useCallback(async () => {
        if (!creativeEditor?.pendingBlob) {
            return;
        }
        try {
            const base64 = await blobToRawBase64(creativeEditor.pendingBlob);
            commitCreativeBase64(creativeEditor.slot, base64, creativeEditor.file.name);
            closeCreativeEditor();
        } catch (err) {
            console.error('Preview commit failed:', err);
            alert('Could not save this creative. Please try again.');
        }
    }, [creativeEditor, closeCreativeEditor, commitCreativeBase64]);

    function onVerticalFileUploadChange(e) {
        processCreativeUpload(e, 'vertical');
    }

    function onHorizontalFileUploadChange(e) {
        processCreativeUpload(e, 'horizontal');
    }
    function handleScreenTypeChoose(e) {
        setSelectedScreenType(e);
        switch (e.value) {
            case 1:
                setMinCPI(.03);
                setMinImpressions(1);
                break;
            case 0:
                setMinCPI(.01);
                setMinImpressions(1);
                break;
        }
    }
    function checkValues() {
        setValuesChecked(true);
    }
    function handleScreenSelectionChange(selection) {
        setSelectedScreenIds(selection.screenIds);
        setFleetSize(selection.fleetSize || 1);
        setMonthlyFee(selection.totalUsd);
        if (selection.screenIds.length > 0) {
            setScreenSelectionError('');
        }
    }

    function onSubmit(e) {
        e.preventDefault();
        if (!selectedScreenIds.length) {
            setScreenSelectionError('Select at least one screen to continue.');
            return;
        }
        if (!campaignHorizontalContent || !campaignVerticalContent) {
            alert("Please upload both horizontal and vertical content.");
            return;
        }
        
        // Prepare campaign data
        const formData = {
            campaignName,
            monthlyFee: monthlyFee,
            selectedScreenIds,
            campaignHorizontalContent,
            campaignVerticalContent,
            // Legacy fields for backwards compatibility
            campaignViewingTime: "12:00:00",
            campaignBudget: `$${monthlyFee.toFixed(2)}`,
            totalCampaignImpressions: selectedScreenIds.length * PLAYS_PER_SCREEN_MONTH,
            costPerImpression: "$0.50",
            selectedLocations: [],
            storefront: 1
        };

        // Store form data and show payment modal
        setTosAccepted(false);
        setTosError('');
        setPendingFormData(formData);
        setShowPayment(true);
    }

    function closePaymentModal() {
        setShowPayment(false);
        setPendingFormData(null);
        setTosAccepted(false);
        setTosError('');
    }
    function getCurrentTimezone() {
        // Get the current date and time in the local timezone
        const currentDate = new Date();

        // Get the timezone from the Intl.DateTimeFormat object
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        setCurrentTimezone(timezone);
    }
    function convertToUTC(timeString) {
        // Create a date object from the input time string
        const date = new Date(`2000-01-01T${timeString}:00-08:00`);

        // Get the time in UTC
        const utcTime = date.toISOString().substr(11, 8);
        return utcTime;
    }

    useEffect(() => {
        campaignImpressionsOnBlur(totalCampaignImpressions)
        cpiOnBlur(costPerImpression)

    }, [minCPI, minImpressions])
    useEffect(() => {
        getAllLocations();
        getCurrentTimezone();
        return () => {

        }
    }, [token]);

    useEffect(() => {
        if (searchParams.get('stripe') === 'cancelled') {
            setSubmitError('Checkout was cancelled. You can try payment again when you are ready.');
        }
    }, [searchParams]);

    useEffect(() => {
        return () => {
            revokeCreativeEditorUrls(creativeEditor);
        };
    }, [creativeEditor, revokeCreativeEditorUrls]);

    return (

        <div className={`advertiserDashboardContainerCampaigns`}>
            
            {/* Success Modal */}
            {submitSuccess && <div className='campaignModalAlert'>
                <span className='registeredScreensTitle advertiserListTitle'>Success!</span>
                <p style={{padding: '1rem', textAlign: 'center'}}>Your campaign has been submitted for review. You will be contacted for payment once approved.</p>
                <div className="campaignModalLoadingOverlay">
                    <RingLoader
                        color={"#C52F00"}
                        loading={true}
                        size={50}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                        className='loaderForOverlay'
                    />
                </div>
            </div>
            }
            {submitSuccess && <div className='campaignModalBackdrop'></div>}
            
            {/* Error Modal */}
            {submitError && <div className='campaignModalAlert'>
                <span className='registeredScreensTitle advertiserListTitle'>Error</span>
                <p style={{padding: '1rem', textAlign: 'center', color: '#C52F00'}}>{submitError}</p>
                <input onClick={() => { setSubmitError("") }} className='advertiserRegisterSubmitBtn' value='Close' />
            </div>
            }
            {submitError && <div className='campaignModalBackdrop'></div>}

            {creativeProcessing && (
                <CreativeProcessingOverlay message={creativeProcessing.message} />
            )}

            {creativeEditor?.step === 'crop' && (
                <CreativeCropModal
                    slot={creativeEditor.slot}
                    imageSrc={creativeEditor.imageSrc}
                    onCancel={handleCreativeEditorCancel}
                    onNext={handleCropNext}
                    exporting={cropExporting}
                />
            )}
            {creativeEditor?.step === 'preview' && (
                <CreativePreviewModal
                    slot={creativeEditor.slot}
                    previewUrl={creativeEditor.previewUrl}
                    isVideo={creativeEditor.isVideo}
                    onCancel={handleCreativeEditorCancel}
                    onNext={handlePreviewNext}
                />
            )}
            
            <div className={`adminDashboardScreenPageContainer ${creativeProcessing ? 'newCampaignFormBlocked' : ''}`}>
                <span className='registeredScreensTitle advertiserListTitle'>New Campaign</span>
                {onboarding?.tourActive && ['campaign_screens', 'campaign_creatives', 'campaign_pay'].includes(onboarding.activeStepId) && (
                    <div className="advertiser-onboarding-campaign-banner">
                        {onboarding.activeStepId === 'campaign_screens' && 'Step 1 of 3: Select the screens where you want your ad to run.'}
                        {onboarding.activeStepId === 'campaign_creatives' && 'Step 2 of 3: Upload horizontal and vertical creatives for your campaign.'}
                        {onboarding.activeStepId === 'campaign_pay' && 'Step 3 of 3: Continue to payment to submit your campaign for approval.'}
                    </div>
                )}
                
                {/* Monthly Fee Banner */}
                <div className='monthlyFeeBanner'>
                    <span className='monthlyFeeText'>
                        {selectedScreenIds.length > 0
                            ? `Campaign fee (${selectedScreenIds.length} screen${selectedScreenIds.length === 1 ? '' : 's'}): $${monthlyFee.toFixed(2)}`
                            : 'Select screens below to see your campaign fee'}
                    </span>
                    <span className='monthlyFeeSubtext'>
                        Each screen includes {PLAYS_PER_SCREEN_MONTH.toLocaleString()} plays per month (180 plays/screen/day × 30 days). Select all Invert screens for ${ALL_SCREENS_BUNDLE_USD.toFixed(2)}.
                    </span>
                    <span className='monthlyFeeNote'>Note: A one-time card payment is required before submission. Your campaign goes through approval after payment.</span>
                </div>

                <form
                    className={creativeProcessing ? 'newCampaignFormBlocked' : ''}
                    onSubmit={(e)=>{onSubmit(e)}}
                >
                    <div data-onboarding-id="campaign-screens">
                    <ScreenSelector
                        selectedScreenIds={selectedScreenIds}
                        onSelectionChange={handleScreenSelectionChange}
                        selectionError={screenSelectionError}
                    />
                    </div>

                    <div style={{ marginBottom: '2rem' }}>
                        <ScreenMapView />
                    </div>

                    <div className='newCampaignInputContainer'>
                        <span className='newCampaignInputTitle'>Campaign Name</span>
                        <input value={campaignName} onChange={(e) => { campaignNameOnChange(e.nativeEvent.target.value)}} required type={"text"} maxLength={50} placeholder='Campaign Name' className='newCampaignInputInputFull'/>
                    </div>
                
                    <div className='newCampaignInputTwoContainer' data-onboarding-id="campaign-creatives">
                        <span className='newCampaignInputTitle'>Horizontal content (16:9 landscape)</span>
                        <span className='newCampaignInputHint'>Images: any aspect ratio — we will help you crop. Large images are resized automatically. {creativeVideoHint('horizontal')}</span>
                        <CreativeFileUpload
                            inputId={CREATIVE_INPUT_IDS.horizontal}
                            accept="image/*,video/mp4,video/x-m4v,video/*"
                            fileName={creativeFileNames.horizontal}
                            isReady={Boolean(campaignHorizontalContent)}
                            disabled={Boolean(creativeProcessing)}
                            onChange={onHorizontalFileUploadChange}
                        />
                    </div>

                    <div className='newCampaignInputTwoContainer'>
                        <span className='newCampaignInputTitle'>Vertical content (9:16 portrait)</span>
                        <span className='newCampaignInputHint'>Images: any aspect ratio — we will help you crop. Large images are resized automatically. {creativeVideoHint('vertical')}</span>
                        <CreativeFileUpload
                            inputId={CREATIVE_INPUT_IDS.vertical}
                            accept="image/*,video/mp4,video/x-m4v,video/*"
                            fileName={creativeFileNames.vertical}
                            isReady={Boolean(campaignVerticalContent)}
                            disabled={Boolean(creativeProcessing)}
                            onChange={onVerticalFileUploadChange}
                        />
                    </div>

                    {/* Legacy fields - Hidden but kept for backwards API compatibility */}
                    <div style={{display: 'none'}}>
                        <input readOnly value={campaignBudget} type={"text"} className='newCampaignInputInputFull' />
                        <input readOnly value={totalCampaignImpressions} type={"text"} className='newCampaignInputInputFull' />
                        <input readOnly value={costPerImpression} type={"text"} className='newCampaignInputInputFull' />
                    </div>

                    <input 
                        type={"submit"} 
                        className='advertiserRegisterSubmitBtn' 
                        data-onboarding-id="campaign-pay"
                        value={selectedScreenIds.length > 0 ? 'Continue to Payment' : 'Select screens to continue'}
                        disabled={Boolean(creativeProcessing) || selectedScreenIds.length === 0}
                    />
               </form>
            </div>

            {/* Payment Modal */}
            {showPayment && (
                <div className='campaignModalAlert' style={{ maxWidth: '800px', width: 'min(92vw, 800px)', maxHeight: '90dvh' }}>
                    <span className='registeredScreensTitle advertiserListTitle'>Complete Payment</span>
                    <p style={{padding: '1rem', textAlign: 'center'}}>
                        One-time payment: ${monthlyFee.toFixed(2)}
                    </p>
                    <p style={{padding: '0 1rem 1rem', textAlign: 'center', fontSize: '0.9rem'}}>
                        Pay with card (Stripe) to submit your campaign for review. Service begins after approval.
                    </p>
                    {pendingRedirect ? (
                        <div className="campaignModalLoadingOverlay">
                            <p style={{marginBottom: '1rem', color: '#4CAF50'}}>Payment successful! Creating campaign...</p>
                            <RingLoader
                                color={"#C52F00"}
                                loading={true}
                                size={50}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                                className='loaderForOverlay'
                            />
                        </div>
                    ) : (
                        <div style={{padding: '1rem'}}>
                            <p style={{ margin: '0 0 0.75rem', fontSize: '0.9rem', color: '#444', textAlign: 'center' }}>
                                One-time payment for {selectedScreenIds.length} selected screen{selectedScreenIds.length === 1 ? '' : 's'} ({PLAYS_PER_SCREEN_MONTH.toLocaleString()} plays per screen / month).
                            </p>
                            <label className="campaign-tos-checkbox">
                                <input
                                    type="checkbox"
                                    checked={tosAccepted}
                                    onChange={(e) => {
                                        setTosAccepted(e.target.checked);
                                        if (e.target.checked) {
                                            setTosError('');
                                        }
                                    }}
                                />
                                <span>
                                    I agree to the{' '}
                                    <Link
                                        to={agreementLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="campaign-tos-link"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        INVERT Advertising Agreement
                                    </Link>{' '}
                                    {tosVersion ? `(version ${tosVersion})` : ''} for this screen-targeted campaign.
                                </span>
                            </label>
                            {tosError && <p className="campaign-tos-error">{tosError}</p>}
                            <PaymentButton
                                setPendingRedirect={setPendingRedirect}
                                data={pendingFormData}
                                cost={monthlyFee.toFixed(2)}
                                tosAccepted={tosAccepted}
                                onTosError={setTosError}
                                onCheckoutError={(msg) => {
                                    setSubmitError(msg);
                                    closePaymentModal();
                                }}
                            />
                            <button
                                type="button"
                                onClick={closePaymentModal}
                                className="advertiserRegisterSubmitBtn"
                                style={{ marginTop: '1rem', backgroundColor: '#666' }}
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                </div>
            )}
            {showPayment && <div className='campaignModalBackdrop'></div>}
        </div>
    )
}
